import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { StoreRootState } from 'services/store/types';
import { ControlComponentProps } from '../types';

type GenreBlendSelector = ControlComponentProps<string>;

const GenreBlendSelector = ({ value, onChange }: GenreBlendSelector) => {
  const genres = useSelector((store: StoreRootState) => store.ai.genres);

  return (
    <FormControl fullWidth>
      <Select
        value={value}
        name="genre-select"
        onChange={(event: SelectChangeEvent) => {
          const { value: newValue } = event.target;
          onChange(newValue);
        }}
      >
        {genres.map(({ id, name }) => (
          <MenuItem key={id} value={name}>
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default memo(GenreBlendSelector);
